import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import { withStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/dialogStyle';

class ScrollableDialog extends React.Component {
	render() {
		const {
			children,
			confirmBtnText = 'Ok',
			cancelBtnText = 'Cancel',
			maxWidth = 'md',
			onConfirm,
			onCancel,
			classes,
		} = this.props;

		return (
			<Dialog
				open={true}
				onClose={onCancel}
				fullWidth={true}
				maxWidth={maxWidth}
				aria-labelledby="scroll-dialog-title"
				aria-describedby="scroll-dialog-description"
			>
				<DialogContent dividers={true}>
					{children}
				</DialogContent>
				<DialogActions style={{ justifyContent: 'center', padding: '25px 0' }}>
					{ onCancel &&
						<Button
							className={`${classes.button} ${classes.dialogButton} ${classes.gray}`}
							onClick={onCancel}
							color="primary"
						>
							{cancelBtnText}
						</Button>
					}
					{
						onConfirm &&
							<Button
								className={`${classes.button} ${classes.danger}`}
								onClick={onConfirm}
								color="primary"
							>
								{confirmBtnText}
							</Button>
					}
				</DialogActions>
			</Dialog>
		)
	}
}

export default withStyles(styles)(ScrollableDialog);
